/**
 * VeeValidate Localization Utility
 *
 * Handles setting up VeeValidate validation message translations.
 */
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';

// Register available locales
Validator.localize('es', es);

/**
 * Set the VeeValidate locale based on the language code.
 *
 * @param {string} language - Language code ('en' or 'es')
 */
export function setValidatorLocale(language) {
  const locale = ['en', 'es'].includes(language) ? language : 'en';
  Validator.localize(locale);
}

export default { setValidatorLocale };
